import ltSaveAlert from 'html/addon/lt-save-alert.html';
import App from 'app/app.js';
import 'app/directive/LtSaveAlertCtrl.js';

function LtSavealertDirective() {
  return {
    restrict: 'E',
    scope: {
      onInit: '&',
      onCancellation: '&',
      navigateUser: '&',
      isOrderEditPage: '='
    },
    template: ltSaveAlert,
    controller: 'LtSaveAlertCtrl',
    controllerAs: 'saveAlert'
  };
}

App.directive('ltSaveAlert', [LtSavealertDirective]);
